import styled from 'styled-components';
import { ButtonTertiary, FormTextarea, IconArrowRight, } from '@spotify-internal/encore-web';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
const SendForm = styled.form `
  display: grid;
  grid-template-columns: 1fr 3rem;
  border-top: 1px solid #dedede;
`;
const SendFormMessageInput = styled(FormTextarea) `
  outline: none;
  box-shadow: none;
  resize: none;
  height: 3rem;
  align-self: center;
  overflow: hidden;

  &:hover,
  &:focus {
    box-shadow: none;
  }
`;
export const SendUploadCaptionControl = ({ onSubmit, }) => {
    var _a;
    const captionCharacterLimit = 150;
    const { t } = useTranslation();
    const [value, setFormValue] = useState('');
    const handleChange = useCallback((ev) => {
        setFormValue(ev.target.value.substring(0, captionCharacterLimit));
    }, [setFormValue]);
    const handleSubmit = useCallback(() => {
        onSubmit(value.trim());
        setFormValue('');
    }, [setFormValue, value, onSubmit]);
    return (React.createElement(SendForm, { onKeyPress: e => {
            if (e.shiftKey && e.key === 'Enter') {
                return;
            }
            else if (e.key === 'Enter') {
                e.preventDefault();
                handleSubmit();
            }
        } },
        React.createElement(SendFormMessageInput, { "data-testid": "caption-message-input", onChange: handleChange, value: value, rows: 1, placeholder: (_a = t('TYPE_IMAGE_CAPTION')) !== null && _a !== void 0 ? _a : 'Type image caption (optional)' }),
        React.createElement(ButtonTertiary, { "data-testid": "caption-send-button", type: "button", "aria-label": "send caption message", iconOnly: IconArrowRight, onClick: handleSubmit })));
};
